import * as React from 'react'
// @ts-ignore
import { Button, Input } from 'relevant-ui'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  reduxForm,
  Field,
  getFormValues,
} from 'redux-form'
import {
  SUBMIT,
  REGENERATE_PASSWORD_FORM,
  OLD_PASSWORD,
  OLD_PASSWORD_LABEL,
  PASSWORD,
  PASSWORD_LABEL,
  PASSWORD_VERIFICATION,
  PASSWORD_VERIFICATION_LABEL,
} from '@App/constantes'
import InputField from '@App/components/fields/InputField'
import { getRegeneratePassword } from 'actions/regeneratePassword'

const NewRegeneratePasswordForm: any = ({
  handleSubmit,
  pristine,
  submitting,
  oldPassword,
  password: propsPassword,
  verification,
  regenerate,
  history,
}: any) => {
  const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/

  const [slider, setSlider] = React.useState(0)
  const [strongPassword, setStrongPassword] = React.useState('Inadéquate - 8 caractères lettres et chiffres')
  const [password, setPassword] = React.useState('')
  const [color, setColor] = React.useState('#AD0000')

  React.useEffect(() => {
    if (password.match(regExp)) {
      setSlider(90)
      setColor('#72C54B')
      setStrongPassword('Adéquate - Mot de passe sécurisé')
    } else {
      setSlider(2)
      setColor('#AD0000')
      setStrongPassword('Inadéquate - min 8 caractères, une majuscule, une lettre et un chiffre')
    }
  })

  const submitForm = () => {
    const body = {
      oldPassword,
      verification,
      password: propsPassword,
    }

    regenerate(body)
  }

  const onCancel = () => {
    history.goBack()
  }

  return (
    <form
      autoComplete="off"
      onSubmit={handleSubmit(submitForm)}
      className="customform form--w920 mt-20"
    >
      <div className="customform__row">
        <div className="formGroup formGroup--large">
          <Field
            component={InputField}
            name={OLD_PASSWORD}
            label={OLD_PASSWORD_LABEL}
            type="password"
            primary
          />
        </div>
      </div>

      <div className="customform__row">
        <div className="formGroup formGroup--large">
          <div className="password">
            <Field
              component={InputField}
              name={PASSWORD}
              label={PASSWORD_LABEL}
              onChange={(pEvt: any) => setPassword(pEvt.target.value)}
              type="password"
              primary
            />
            <div className="password__strong">
              <h2 className="password__strong__title">{strongPassword}</h2>
              <div className="password__strong__value">
                <div style={{ width: `${slider || 0}%`, backgroundColor: color }}
                  className="password__strong__value__slider"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="customform__row">
        <div className="formGroup formGroup--large">
          <Field
            component={InputField}
            name={PASSWORD_VERIFICATION}
            label={PASSWORD_VERIFICATION_LABEL}
            type="password"
            primary
          />
        </div>
      </div>

      <div className="wrapperButton">
        <Button
          button="withoutBackground"
          size="large"
          type="button"
          label="Retour"
          onClick={onCancel}
          withoutBackground
        />
        <Button
          button="primary"
          size="large"
          type="submit"
          disabled={pristine || submitting}
          label={SUBMIT}
        />
      </div>
    </form>
  )
}

const validate = (values: any) => {
  const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
  const errors = {}

  if (
    (values[PASSWORD] && !values[PASSWORD].match(regExp)) ||
    values[PASSWORD] !== values[PASSWORD_VERIFICATION]
  ) {
    errors[PASSWORD] = 'Not yet !'
  }

  if (
    values[PASSWORD_VERIFICATION] && !values[PASSWORD_VERIFICATION].match(regExp) ||
    values[PASSWORD] !== values[PASSWORD_VERIFICATION]
  ) {
    errors[PASSWORD_VERIFICATION] = 'Not yet !'
  }

  return errors
}

const RegeneratePassword = reduxForm<any, any, any>({
  validate,
  form: REGENERATE_PASSWORD_FORM,
  enableReinitialize: true,
})(NewRegeneratePasswordForm)

const mapStateToProps = (state: any) => {
  const values = getFormValues(REGENERATE_PASSWORD_FORM)(state) || {}

  return {
    ...values,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    regenerate: (body: any) => dispatch(getRegeneratePassword(body)),
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(RegeneratePassword)
